'use client'

import { useTranslations } from 'next-intl'

import { DesktopBrand } from './desktop-brand'

export function SiteFooter() {
  const t = useTranslations('studio-desktop-landing-pages.lps.shared.footer')

  return (
    <footer className="border-t border-sd-border">
      <div className="mx-auto flex max-w-[1120px] flex-wrap items-center justify-between gap-4 px-5 py-9 md:px-10">
        <div className="flex items-center gap-2">
          <DesktopBrand />
        </div>
        <div className="flex flex-wrap gap-4 text-[13px] text-sd-slate-3">
          <p>{t('copyright')}</p>
          <p>
            {t('privacy')} · {t('terms')}
          </p>
        </div>
      </div>
    </footer>
  )
}
